import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ContactService {
  private http = inject(HttpClient);
  // Optional: Ziel-Endpoint konfigurierbar machen
  private endpoint = '/api/contact'; // Platzhalter; kann später angepasst werden

  submitContact(payload: { name: string; email: string; message: string }) {
    // Fallback: Wenn kein echter Endpoint existiert, trotzdem sauber abschließen
    return this.http.post(this.endpoint, payload, { observe: 'response' });
  }
}